import axiosInstance from '../config/axios.config';

const BASE = '/user/dashboard';

export const getUserDashboardKpi = async () => {
    const response = await axiosInstance.get(`${BASE}/kpi`);
    return response.data;
};

export const getUserDashboardTrend = async () => {
    const response = await axiosInstance.get(`${BASE}/trend`);
    return response.data;
};

export const getUserDashboardActivity = async (limit = 15) => {
    const response = await axiosInstance.get(`${BASE}/activity`, { params: { limit } });
    return response.data;
};

export const getUserDashboardLeads = async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/leads`, { params });
    return response.data;
};
